// extracted by mini-css-extract-plugin
module.exports = {"root":"hhKdU4","text":"c-2gaUS","link":"VDXPCp","table":"c1Z8_fS"};